import D2C_ProviderStorage from './Storage'

class D2C_ProviderBackblaze extends D2C_ProviderStorage {
  static objectType = 'providerType'
  static active = true
  static order = 34
  static providerType = 'Backblaze'
  static providerTitle = 'Backblaze'
  static fields = {
    ...D2C_ProviderStorage.fields,
    accessId: {
      default: '',
      label: 'Account ID',
      path: 'auth.accessId',
      required: true,
      validate(value) {
        return (value && value.length > 0) ? null : 'Must be filled'
      },
      creating: {},
    },
    secretKey: {
      default: '',
      label: 'Application Key',
      path: 'auth.secretKey',
      required: true,
      validate(value) {
        return (value && value.length > 0) ? null : 'Must be filled'
      },
      creating: {},
    }
  }
}

export default D2C_ProviderBackblaze
